import { useSelectedAccount } from "../../contexts/AccountContext"
import "../../styles/account-selection-notice.scss"

type Props = {
  /**
   * ページ固有のスタイルを重ねたいときに渡す（例: AI レポートの `ai-report__muted`）。
   * 基底クラス `.account-selection-notice` には常に付与される。
   */
  className?: string
}

/**
 * アカウント未選択時の案内文。各ページの「アカウントを選択してください」を1箇所に集約する。
 *
 * 案内の末尾に Instagram アカウント追加手順（`/instagram-setup-guide.html`）への導線を出すのは
 * 次の2条件をどちらも満たすときだけ。
 *
 * - 選択中の組織にアカウントが1件も無い: 「選択してください」と言われても選ぶ対象が存在せず、
 *   ユーザーはそこで行き止まりになる。まずアカウントを追加する必要があると伝える必要がある。
 * - 選択中の組織でのロールがオーナー: アカウントを追加できるのはオーナーだけなので、
 *   メンバーに追加手順を見せても実行できず、案内として成立しない（組織のオーナーに依頼する話になる）。
 *
 * アカウントが1件以上あるときは単に未選択なだけで行き止まりではないため、リンクは出さない。
 */
const AccountSelectionNotice = ({ className }: Props) => {
  const { organizations, selectedOrganizationId, selectedOrganizationRole } = useSelectedAccount()

  const selectedOrganization = organizations.find(o => o.id === selectedOrganizationId)
  const hasNoAccounts = (selectedOrganization?.accounts.length ?? 0) === 0
  const showSetupGuide = selectedOrganizationRole === "owner" && hasNoAccounts

  return (
    <p className={className ? `account-selection-notice ${className}` : "account-selection-notice"}>
      アカウントを選択してください
      {showSetupGuide && (
        <a
          className="account-selection-notice__link"
          href="/instagram-setup-guide.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          詳しくはこちら
        </a>
      )}
    </p>
  )
}

export default AccountSelectionNotice
